<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-25 pt-6 pb-6 px-5 relative">
                    <div class="absolute top-6 right-5">
                        <img class="w-18px cursor-pointer"
                             src="../../../../assets/close/close.png"
                             @click="clickClose()">
                    </div>
                    <div class="text-tc-blue-1 text-24 text-center mb-4">{{lbl.home.login.register_login}}</div>
                    <InputUsername
                            v-model:inputValue="inputUsername"
                            delimeter="-"
                            :placeholderText="lbl.home.login.place_username"
                    ></InputUsername>
                    <div v-if="errorMsg != ''" class="text-tc-orange-1 text-center text-18 pt-10px pb-1">
                        {{errorMsg}}
                    </div>
                    <div class="text-a-blue-1c3e95 text-18 underline text-right pt-10px cursor-pointer"
                        @click="onClickForgetPassword()">
                        {{ lbl.forgetpassword.forgetpassword }}  ?
                    </div>
                    <BlueBtn paddingClass="px-4 py-10px" class="mt-3" @click="clickLogin()">
                        <span class="text-20">{{lbl.home.login.confirm}}</span>
                    </BlueBtn>
                    <div class="flex items-center mt-5 mb-5">
                        <div class="flex-1 bg-tc-gray-5 h-1px"></div>
                        <div class="px-2 text-20 text-tc-gray-7">{{lbl.home.login.or}}</div>
                        <div class="flex-1 bg-tc-gray-5 h-1px"></div>
                    </div>
                    <GreenLineBtn @click="loginLine()">
                        <div class="flex items-center justify-center">
                            <div>
                                <img class="w-5" src="../../../../assets/social/line.svg">
                            </div>
                            <div class="text-22 ml-1">{{lbl.home.login.login_line}}</div>
                        </div>
                    </GreenLineBtn>
                    <BlueFacebookBtn class="mt-4" @click="loginWithFB()">
                        <div class="flex items-center justify-center">
                            <div>
                                <img class="w-5" src="../../../../assets/social/facebook.svg">
                            </div>
                            <div class="text-22 ml-1">{{lbl.home.login.login_facebook}}</div>
                        </div>
                    </BlueFacebookBtn>
                    <div class="text-tc-gray-1 text-20 text-center mt-5">
                        {{lbl.home.login.cant_login}}
                    </div>
                    <!-- <button class="text-30 text-center" @click="clickRegister()">register</button> -->
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import FBFunction from '@/helper/facade/FBFunction.js';
import RegxHelper from "@/helper/RegxHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import InputUsername from "@/components/Input/simple/InputUsername.vue";
import BlueBtn from "@/components/Button/BlueBtn.vue";
import GreenLineBtn from "@/components/Button/GreenLineBtn.vue";
import BlueFacebookBtn from "@/components/Button/BlueFacebookBtn.vue";
//service
import UserLoginApi from '../../service/UserLoginApi.js';
import FbAuthApi from '@/core/Account/service/FbAuthApi.js';
import { AuthFacebookConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import CacheHelper from '@/helper/CacheHelper';
import Account from '@/helper/AccountHelper.js';
export default {
    name: "LoginModal",
    mixins: [LocaleMixin],
    components: {
        InputUsername,
        BlueBtn,
        GreenLineBtn,
        BlueFacebookBtn,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            inputUsername: '',
            phoneNumber: '',
            errorMsg: '',
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function() {
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
            this.errorMsg = '';
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickClose: function() {
            this.hide();
        },

        clickLogin: function() {
            if (!Util.isEmptyStr(this.inputUsername)) {
                this.phoneNumber = RegxHelper.removeNotNumber(this.inputUsername)
                if(RegxHelper.isContactNumber(this.phoneNumber)){
                    this.setRegisterChannel('buzzebees')
                    this.checkUser(this.phoneNumber);
                }else{
                    this.errorMsg = this.lbl.home.login.mobile_incorrect;
                }
            } else {
                this.errorMsg = this.lbl.home.login.mobile_incorrect;
            }
        },
        loginLine: function() {
            this.setRegisterChannel('line')
            window.location.replace('/linelogin');
        },
        loginWithFB: async function () {
            console.log('login facebook')
            this.isFBLogin = true;
            let fbLoginStatus = await this.fbLoginStatus()
            if (fbLoginStatus == null) {
                this.controller.loadingModal.show();
                fbLoginStatus = await this.loginFB();
                this.controller.loadingModal.hide();
            }

            if (fbLoginStatus != null) {
                let fbAccessToken = fbLoginStatus.accessToken;
                // alert('access token', fbAccessToken);
                this.loginBzbs(fbAccessToken);
            }
        },
        fbLoginStatus: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.getLoginStatus().then((fbData) => {
                    // alert('fb login status', JSON.stringify(fbData));
                    resolve(fbData);
                }).catch(() => {
                    resolve(null);
                    // alert('fb error', JSON.stringify(err));
                });
            });
        },
        loginFB: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.login().then((data) => {
                    // alert('fb login', JSON.stringify(data));
                    resolve(data);
                }).catch(() => {
                    // alert('fb login error', JSON.stringify(err));
                    resolve(null);
                });
            });
        },
        loginBzbs: async function (fbAccessToken) {
            let authConfig = new AuthFacebookConfigBuilder()
                .genUUID()
                .setFacebookToken(fbAccessToken)
                .create()
                .getParams();

            let loginRs = await this.apiLoginFacebook(authConfig)

            if (loginRs) {
                window.location.replace('/home');
            }
        },
        apiLoginFacebook: function (params) {
            return new Promise((resolve) => {
                FbAuthApi.apiLoginFacebook(params).subscribe({
                    next: (user) => {
                        console.log(user)
                        Account.setCacheUser(user);
                        resolve(true);
                    },
                    error: (err) => {
                        this.hide();
                        if (err.id == 2123) {
                        this.controller.confirmModal
                            .clearModal()
                            .setTitle(this.lbl.register.no_data)
                            .setMsg(this.lbl.register.unregister)
                            .setBtnOk(this.lbl.register.confirm)
                            .show()
                        this.controller.confirmModal.onClickOk(() => {
                            this.setRegisterChannel('facebook')
                            this.$router.replace('/termandcondition');
                        });
                        } else {
                            this.showError(err.message);
                        }
                        resolve(false);
                    },
                })
            });
        },
        openPasswordModal: function(mode) {
            let passwordType = mode == 'pin' ? 'pin' : 'password';
            this.hide();
            this.controller.passwordModal
                    .clearModal()
                    .setUsername(this.inputUsername)
                    .setPasswordType(passwordType)
                    .show();

            this.controller.passwordModal.onClickClose(() => {
                this.show();
            });
        },
        showError: function(errMsg) {
            this.hide();
            this.controller.alertModal
                    .clearModal()
                    .setMsg(errMsg)
                    .show();
            this.controller.alertModal.onClickOk(() => {
                this.show();
            });
        },

        //#region api
        checkUser: function(username) {
            this.controller.loadingModal.show();
            UserLoginApi.getAccountType(username).subscribe({
                next: (data) => {
                    this.controller.loadingModal.hide();
                    this.hide();
                    console.log('account type', data);
                    if (data.passwordType == "password") {
                        this.openPasswordModal('password');
                    } else {
                        this.openPasswordModal('pin');
                    }
                },
                error: (err) => {
                    console.log(err);
                    this.controller.loadingModal.hide();
                    this.hide();
                    if (err.id == 404) {
                        this.controller.confirmModal
                            .clearModal()
                            .setTitle(this.lbl.register.no_data)
                            .setMsg(this.lbl.register.unregister)
                            .setBtnOk(this.lbl.register.confirm)
                            .show()
                        this.controller.confirmModal.onClickOk(() => {
                            this.setRegisterChannel('buzzebees')
                            this.$router.replace('/termandcondition');
                        });
                    } else {
                        this.showError(err.message);
                    }
                },
            })
        },
        //#endregion api
        setRegisterChannel: function(channel){
            let cache = new CacheHelper('local');
            cache.setCache('register_channel',channel);
            console.log(channel)
        },
        onClickForgetPassword: function(){
            this.$router.push('/forgetpassword')
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 340px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }
</style>
